<template>
  <div class="w-full rounded-md grid grid-cols-12 relative py-4">
    <div class="col-span-2 flex items-center px-4 text-lg">{{ label }}</div>
    <div class="col-span-5">
      <div
        v-if="!isArray(previous) && previous"
        class="rounded-md flex bg-red-100 h-12 w-4/5 !shadow"
      >
        <div
          class="w-12 bg-red-200 flex items-center justify-center rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-red-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
          </svg>
        </div>
        <div class="px-3 flex items-center" style="white-space: pre;">{{ previous }}</div>
      </div>
      <div v-if="isArray(previous)" class="space-y-3">
        <div
          v-for="(change, index) in previous"
          :key="`${change}${index}`"
          class="rounded-md flex bg-red-100 h-12 w-4/5 !shadow h-fit"
        >
          <div
            class="w-12 bg-red-200 flex items-center justify-center rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-red-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M20 12H4"
              />
            </svg>
          </div>
          <div class="px-3 flex items-center" style="white-space: pre;">{{ change }}</div>
        </div>
      </div>
    </div>
    <div class="col-span-5">
      <div
        v-if="!isArray(current) && current"
        class="rounded-md flex bg-green-100 h-12 w-4/5 !shadow"
      >
        <div
          class="w-12 bg-green-200 flex items-center justify-center rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-green-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>
        <div class="px-3 flex items-center" style="white-space: pre;">{{ current }}</div>
      </div>
      <div v-if="isArray(current)" class="space-y-3">
        <div
          v-for="(change, index) in current"
          :key="`${change}${index}`"
          class="rounded-md flex bg-green-100 h-12 w-4/5 !shadow h-fit"
        >
          <div
            class="w-12 bg-green-200 flex items-center justify-center rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-green-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4v16m8-8H4"
              />
            </svg>
          </div>
          <div class="px-3 flex items-center" style="white-space: pre;">{{ change }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil, isArray, difference } from 'lodash'
import DropdownLists from '../../components/DropdownLists.json'

import time from '../../services/utils/time.js'

export default {
  props: {
    data: Array,
    programs: Array,
    scheduleChange: Boolean,
    schedule: Array,
    prevSchedule: Array,
  },
  data() {
    return {
      references: DropdownLists,
      overrides: {
        'endDate': 'Last Day of Transportation',
        'inboundDays': 'Inbound Selected Days',
        'outboundDays': 'Outbound Selected Days',
        'inboundDayDifferent': 'Inbound\n(Day-Variant)',
        'outboundDayDifferent': 'Outbound\n(Day-Variant)',
      },
    }
  },
  methods: {
    camelCaseToText(camelCase) {
      if (typeof camelCase == 'string') {
        return camelCase
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
      }
      return camelCase
    },
    isAddress(address) {
      if (isNil(address)) {
        return false
      }
      if (!address.street && !address.apartment && !address.city && !address.state && !address.zip_code) {
        return false
      }
      return true
    },
    convertDataToText(data) {
      if (isNil(data)) {
        return false
      } else if (isArray(data)) {
        if (data.length === 0) {
          return false
        }
      }
      return data
    },
    convertDataToAddress(data) {
      if (isNil(data.street)) {
        data = data[0]
      }
      return `${data?.street}${
        (isNil(data.apartment) || data.apartment=='') ? '' : ` #${data.apartment}`
      }, ${data.city}, ${data.state} ${data.zip_code}`
    },
    formatDate(data) {
      console.log(data)
      if (data) {
        return new Date(data).toLocaleString('en-US', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: 'UTC',
        })
      }
    },
    formatTime(data) {
      if (data) {
        return time.formatAMPM(data)
      }
    },
    applySpecialCases(key, data, isPrev = false) {
      switch (key) {
        case 'needVestProvided':
          return (data) ? 'Yes' : 'No'
        case 'homeAddress':
        case 'newDropoffAddress':
        case 'newPickupAddress':
        case 'schoolAddress':
          if (isNil(data)) {
            return data
          } else {
            return this.convertDataToAddress(data)
          }
        case 'specialNeeds':
          var needsListDisplay = difference(
            data.needsList.map(item => this.references.specialNeeds[item]),
            this.data[1].needsList.map(item => this.references.specialNeeds[item])
          )
          var infoAideIndex = needsListDisplay.indexOf(this.references.specialNeeds['infoAide'])
          if (infoAideIndex >= 0) {
            needsListDisplay[infoAideIndex] = this.references.Aides[data.aide]
          }
          return needsListDisplay
        case 'studentRelease':
          return this.references[key][data]
        case 'grade':
        case 'gender':
        case 'language':
          return this.references[key + 'List'][data]
        case 'program':
          return this.programs.find(item => item.id === data).description
        case 'arrivalTime':
        case 'startTime':
        case 'schoolEndTime':
        case 'departureTime':
          return this.formatTime(data)
        case 'startDate':
        case 'endDate':
          return this.formatDate(data)
        case 'inboundDays':
          if (this.scheduleChange) {
            let retVal = []
            for (const day of data) {
              if (isPrev) {
                // let item = this.prevSchedule[0].find(el => el.day == day)
                // retVal.push(`${day}:\n${this.formatTime(item.programTime)}\n${this.convertDataToAddress(item.address)}`)
                retVal.push(day)
              }
              else {
                // let item = this.schedule[0].find(el => el.day == day)
                // retVal.push(`${day}:\n${this.formatTime(item.programTime)}\n${this.convertDataToAddress(item.address)}`)
                retVal.push(day)
              }
            }
            return retVal
          }
          return data
        case 'outboundDays':
          if (this.scheduleChange) {
            let retVal = []
            for (const day of data) {
              if (isPrev) {
                retVal.push(day)
                // let item = this.prevSchedule[1].find(el => el.day == day)
                // retVal.push(`${day}:\n${this.formatTime(item.programTime)}\n${this.convertDataToAddress(item.address)}`)
              }
              else {
                retVal.push(day)
                // let item = this.schedule[1].find(el => el.day == day)
                // retVal.push(`${day}:\n${this.formatTime(item.programTime)}\n${this.convertDataToAddress(item.address)}`)
              }
            }
            return retVal
          }
          return data
        case 'inboundDayDifferent':
        case 'outboundDayDifferent':
          if (this.scheduleChange) {
            let retVal = []
            for (const dayObj of data) {
              let displayNoChange = true
              let label = `${dayObj.day}:`
              if (dayObj.programTime) {
                displayNoChange = false
                label += `\nprogram time: ${this.formatTime(dayObj.programTime)}; `
              }
              if (dayObj.transportTime) {
                displayNoChange = false
                label += `transport time: ${this.formatTime(dayObj.transportTime)}`
              }
              if (this.isAddress(dayObj.address)) {
                displayNoChange = false
                label += `\n${this.convertDataToAddress(dayObj.address)}`
              }
              if (displayNoChange) {
                label += ' No day variant'
              }
              retVal.push(label)
            }
            return retVal
          }
          return data

        default:
          return data
      }
    },
    isArray(input) {
      return isArray(input)
    },
  },
  computed: {
    label: function () {
      if (this.data[3]) {
        return this.data[3]
      }
      if (this.data[0] in this.overrides) {
        return this.overrides[this.data[0]]
      }
      return this.camelCaseToText(this.data[0])
    },
    previous: function () {
      const data = this.applySpecialCases(this.data[0], this.data[1], true)
      return this.convertDataToText(data)
    },
    current: function () {
      const data = this.applySpecialCases(this.data[0], this.data[2])
      return this.convertDataToText(data)
    },
  },
}
</script>

<style></style>
